import {
  Radio,
  DatePicker,
  Select,
  Button,
  Input,
  Modal,
  message,
  Upload,
  Spin,
  ConfigProvider,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import "./index.styl";
import { useCallback, useEffect, useRef, useState } from "react";
import { getServerTimeOptions } from "../../../utils/smartBeans";
import {
  getMainModuleList,
  getChildModuleList,
  getRoleList,
} from "../../../api/common";
import {
  addSmartBeansReq,
  reduceSmartBeansReq,
  uploadSmartBeansByExel,
} from "../../../api/smartBeans";
import {
  createStudentInfo,
  postStudentInfoByExcel,
} from "../../../api/studentInfo";
import locale from "antd/locale/zh_CN";
import "dayjs/locale/zh-cn";
import { resetLoginInfo } from "../../../utils/common";
import { getStorageValByKey, STORAGE_KEY } from "../../../utils/storage";
import { getTermsData } from "../../../utils/smartBeans";
import {
  BASE_URL,
  SMART_BEANS_UPLOAD_TEMPLATE_URL,
} from "../../../utils/request";
import { sortByChinese } from "../../../utils/smartBeans";

const { Dragger } = Upload;

export default function StudentInfoAdd() {
  const [batchAction, setBatchAction] = useState(2);
  const [showComfirmModal, setShowComfirmModal] = useState(false);

  const [countrysideData, setCountrysideData] = useState([]);
  const [defaultCountrysideKey, setDefaultCountrysideKey] = useState("");

  const [nickname, setNickname] = useState("");
  const fileUrl = useRef("");
  const isLoading = useRef(false);

  const [smartBeanAction, setSmartBeanAction] = useState(1);

  const [uploadFileList, setUploadFileList] = useState([]);

  const [phoneNo, setPhoneNo] = useState("");
  const [sexId, setSexId] = useState(null);
  const [periedKey, setPeriedKey] = useState(null);
  const [periedData, setPeriedData] = useState(getTermsData());

  const [showErrorModel, setShowErrorModel] = useState(false);
  const errorInfo = useRef([]);

  const onPeriedChanged = useCallback((id, option) => {
    setPeriedKey(id);
  }, []);
  const onSexChanged = useCallback((id, option) => {
    setSexId(id);
  }, []);

  const onPhoneNoChanged = useCallback((e) => {
    setPhoneNo(e.target.value);
  }, []);

  const onNicknameChanged = useCallback((e) => {
    console.log(e.target.value);
    setNickname(e.target.value);
  }, []);

  const updateDataByExel = useCallback(async () => {
    if (!fileUrl.current) {
      message.warning("请先上传文件！");
      return;
    }
    const res = await postStudentInfoByExcel({
      excel_url: fileUrl.current,
    });
    if (res.code == 0 && res.data?.length < 1) {
      message.success("批量导入成功！");
    } else {
      errorInfo.current = res.data;
      setShowErrorModel(true);
      message.error("批量导入失败！");
    }

    fileUrl.current = "";
    setUploadFileList([]);
  }, [smartBeanAction]);

  const props = {
    // fileList: uploadFileList,
    headers: {
      Authorization: `Bearer ${getStorageValByKey(STORAGE_KEY.token)}`,
    },
    name: "file",
    maxCount: 1,
    multiple: false,
    action: `${BASE_URL}/common/file/upload`,
    onChange(info) {
      const { status, response } = info.file;
      if (status === "uploading" && !isLoading.current) {
        isLoading.current = true;
        message?.loading(
          {
            content: "",
            icon: <Spin tip="文件上传中..." />,
            style: { padding: 0 },
            // className: "loading",
          },
          [12]
        );
      }
      console.log("status:", status);
      if (status === "done") {
        if (response.code == 0 && response.data > "") {
          fileUrl.current = response.data;
          setUploadFileList([response.data]);
        }
        message.destroy();
        isLoading.current = false;
      } else if (status === "error") {
        message.error(`${info.file.name} 批量导入失败！`);
        message.destroy();
        isLoading.current = false;
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  // 村落数据
  useEffect(() => {
    async function fetchCountryList() {
      const newCountrysideData = []; //{ id: "0", name: "全部" }
      const res = await getChildModuleList({ main_depart_id: 11 }); //自然村数据
      if (res.code == 0 && res.data?.length > 0) {
        newCountrysideData.push(...res.data);

        setCountrysideData(sortByChinese(newCountrysideData));
        setDefaultCountrysideKey(newCountrysideData[0].id);
      }
      console.log(res);
    }
    fetchCountryList();
  }, []);

  // reset录入数据
  const resetInputData = useCallback(() => {
    setBjAccount("");
    setDefaultCountrysideKey("");
    setNickname("");
    setSexId(null);
    setPhoneNo("");
    setDefaultCountrysideKey(null);
    setPeriedKey(null);
  }, []);

  // 帐号
  const [bjAccount, setBjAccount] = useState("");
  const accountStr = useRef("");
  const onAccountStrChanged = useCallback((e) => {
    accountStr.current = e.target.value;
    setBjAccount(e.target.value);
  }, []);

  const onCountrysideItemSelected = useCallback(async (id, option) => {
    setDefaultCountrysideKey(id);
    if (id > "") {
      // const res = await getRoleList({ depart_id: id });
      // if (res.code == 0 && res.data?.length > 0) {
      //   const roleData = res.data;
      // }
    }
  }, []);

  const onBatchActionChanged = useCallback((e) => {
    setBatchAction(e.target.value);
  }, []);

  const verifySingleInputData = useCallback(() => {
    if (!nickname) {
      message.warning("请输入昵称！");
      return false;
    }

    if (!sexId && sexId !== 0) {
      message.warning("请选择性别！");
      return false;
    }

    if (!accountStr.current) {
      message.warning("请输入必经学号！");
      return false;
    }

    const regex = /^BJ\d{7}$/;
    if (regex.test(accountStr.current) === false) {
      message.warning("请输入正确的必经学号！");
      return false;
    }

    if (!phoneNo) {
      message.warning("请输入手机号！");
      return false;
    }

    if (!defaultCountrysideKey) {
      message.warning("请选择所属村落！");
      return false;
    }

    if (!periedKey) {
      message.warning("请选择第几期数据！");
      return false;
    }

    return true;
  }, [nickname, sexId, phoneNo, periedKey, defaultCountrysideKey]);

  // 确认提交
  const onCommit = useCallback(async () => {}, []);

  return (
    <div className="container">
      <div className="btnContainer">
        <Radio.Group onChange={onBatchActionChanged} value={batchAction}>
          <Radio value={1}>批量操作</Radio>
          <Radio value={2}>非批量操作</Radio>
        </Radio.Group>
      </div>
      {batchAction == 1 ? (
        <div className="batchActionContainer" style={{ marginTop: 40 }}>
          <div className="item">
            <span className="itemTitle">上传文件：</span>
            <Dragger {...props}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                点击或者拖拽文件到区域可以完成上传
              </p>
              <p className="ant-upload-hint">支持模版Excel文件上传</p>
            </Dragger>
            <Button
              style={{ marginTop: 20 }}
              className="searchItem"
              onClick={() => {
                window.location.href =
                  "https://static.bjzl.net.cn/wisdom-bean/1728662920539-基本信息导入模版.xlsx";
              }}
              type="link"
            >
              下载模版
            </Button>
          </div>
          <div style={{ height: 120 }} />
          <div className="commitBtnContainer">
            {/* <span>文件上传中...</span> */}
          </div>
          <div className="commitBtnContainer">
            <Button
              style={{ marginTop: 20 }}
              className="searchItem"
              type="primary"
              onClick={updateDataByExel}
            >
              确认提交
            </Button>
          </div>
        </div>
      ) : (
        <div className="batchActionContainer">
          <div className="item">
            <span className="itemTitle">
              <span style={{ color: "red" }}>* </span>学员昵称：
            </span>
            <Input
              value={nickname}
              onChange={onNicknameChanged}
              style={{ height: 32, width: 160 }}
            />
          </div>
          <div className="item">
            <span className="itemTitle">
              <span style={{ color: "red" }}>* </span>学员性别：
            </span>
            <Select
              value={sexId}
              style={{ width: 160 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onSexChanged}
              options={[
                { name: "男", id: 1 },
                { name: "女", id: 0 },
              ]}
            />
          </div>
          <div className="item">
            <span className="itemTitle">
              <span style={{ color: "red" }}>* </span>必经之路学号：
            </span>
            <Input
              value={bjAccount}
              onChange={onAccountStrChanged}
              style={{ height: 32, width: 160 }}
            />
            <span
              style={{
                display: "inline-block",
                marginLeft: 20,
                color: "#999999",
              }}
            >
              (BJ1234567)
            </span>
          </div>
          <div className="item">
            <span className="itemTitle">
              <span style={{ color: "red" }}>* </span>手机号：
            </span>
            <Input
              value={phoneNo}
              onChange={onPhoneNoChanged}
              style={{ height: 32, width: 160 }}
            />
          </div>
          <div className="item">
            <span className="itemTitle">
              <span style={{ color: "red" }}>* </span>所属村落：
            </span>
            <Select
              value={defaultCountrysideKey}
              style={{ width: 160 }}
              onChange={onCountrysideItemSelected}
              fieldNames={{ label: "name", value: "id" }}
              options={countrysideData}
            />
            <span style={{ marginLeft: 20 }} className="itemTitle">
              <span style={{ color: "red" }}>* </span>第几期：
            </span>
            <Select
              value={periedKey}
              style={{ width: 160 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onPeriedChanged}
              options={periedData}
            />
          </div>

          <div className="commitBtnContainer">
            <Button
              onClick={async () => {
                const res = verifySingleInputData();
                if (!res) return;
                const params = {
                  gender: sexId,
                  natural_village: defaultCountrysideKey,
                  natural_village_batch_order: periedKey,
                  nick_name: nickname,
                  phone_no: phoneNo,
                  user_no: bjAccount,
                };
                const inserRes = await createStudentInfo(params);
                if (inserRes.code == 0) {
                  message.success("新增成功！");
                  resetInputData();
                } else {
                  message.error("新增失败！");
                }
              }}
              style={{ marginTop: 20 }}
              className="searchItem"
              type="primary"
            >
              确认提交
            </Button>
          </div>
        </div>
      )}
      <Modal
        title="基础信息导入错误信息"
        open={showErrorModel}
        width={500}
        onCancel={() => {
          setShowErrorModel(false);
        }}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            maxHeight: 500,
            overflow: "scroll",
            // alignItems: "center",
            // justifyContent: "center",
            flexDirection: "column",
            paddingTop: 30,
            paddingRight: 50,
            paddingLeft: 50,
          }}
        >
          {errorInfo.current.map((item) => {
            return (
              <div style={{ marginBottom: 10 }}>
                <span style={{ color: "red" }}>
                  {"第" + item.row_num + "行"}
                </span>
                {": " + item.reason + "\n"}
              </div>
            );
          })}
        </div>
      </Modal>
    </div>
  );
}
